import angular from 'angular';

angular.module('cloudX').directive('cxRelationTypeButtonGroup', [
  'enumCacheSvc',
  '$filter',
  '$rootScope',
  function(enumCacheSvc, $filter, $rootScope) {
    return {
      restrict: 'E',
      replace: true,
      template: `<div role="group" aria-label="relationType" class="btn-group btn-group-justified">
            <button ng-click="toggleRelationType(t.id)"
              ng-repeat="t in items track by t.id"
              type="button"
              title="{{t.label}}"
              class="btn btn-default no-overflow"
              ng-class="{active: selectedTypes.includes(t.id)}">
              <i class="fa margin5R"
              ng-class="{'fa-industry': t.id === 0,'fa-briefcase': t.id === 1,'fa-user': t.id === 2}"></i>{{t.label}}
            </button>
        </div>`,
      scope: {
        placeholder: '@?',
        singleSelect: '<?',
      },
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;

        $scope.items = [];
        $scope.selectedTypes = [];

        enumCacheSvc.get('relationType').then(function(data) {
          $scope.items = data.map(x => ({ id: x.key, value: x.value, label: x.value }));
          translateLabels();
        });
        function translateLabels() {
          $scope.items.forEach(function(item) {
            item.label = $filter('translateList')(item.id, 'relationType', item.value);
          });
        }
        var deregistration = $rootScope.$on('$translateChangeSuccess', translateLabels);
        $scope.$on('$destroy', deregistration);

        $scope.toggleRelationType = function(relType) {
          if ($scope.singleSelect) {
            $scope.selectedTypes = [relType];
          } else {
            const idx = $scope.selectedTypes.indexOf(relType);
            if (idx >= 0) {
              $scope.selectedTypes.splice(idx, 1);
            } else {
              $scope.selectedTypes.push(relType);
            }
          }
          ngModel.$setViewValue([...$scope.selectedTypes]);
        };

        ngModel.$render = function() {
          var value = ngModel.$viewValue;
          if (value !== null && typeof value !== 'undefined') {
            $scope.selectedTypes = [...value];
          }
        };
      },
    };
  },
]);
